import StoreModel from 'models/Index';
import React, { FC, Fragment } from 'react';
import GoMainMenuButton from './HomeButton';
import { observer, inject } from 'mobx-react';
import { Services } from 'helpers/constants/Services';
import { withRouter, RouteComponentProps } from 'react-router';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ThemeType } from 'interfaces';

interface FooterProps extends RouteComponentProps<any>, WithTranslation {}
interface FooterPropsInjected extends FooterProps {
    Store: StoreModel;
}

const useStyles = makeStyles({
    footerInfo: {
        fontSize: '1.125em',
        justifySelf: 'flex-start',
        width: '240px',
        color: (theme: ThemeType) => theme.footer.fontColor,
    },
});

const Footer: FC<FooterPropsInjected> = (props) => {
    const injected = props as FooterPropsInjected;
    const {
        Store: { kioskName, hideBackToHome, shellClient, deviceProfile },
    } = injected;

    const classes = useStyles(deviceProfile.theme);

    return (
        <Fragment>
            <Typography className={classes.footerInfo}>
                Kiosk Id: {kioskName}
            </Typography>
            {!shellClient.cashAcceptor.isCashWasProcessed &&
                !hideBackToHome && <GoMainMenuButton />}
        </Fragment>
    );
};

export default withTranslation()(
    withRouter(inject(Services.STORE)(observer(Footer)))
);
